import GlobalRequest from '../api/global-request';

const PERMISSION_URL = 'v2/admin/permissions';

export default class PermissionService {
    async getPermissions(params) {
        return await GlobalRequest.getRequest(PERMISSION_URL, {
            params,
        });
    }
}
